<template>
    <div>

        <config-main-title v-if="!setup">
            Contratos de Operadoras
        </config-main-title>

        <div v-if="!em_edicao && !setup">

            <div class="form-row mb-2">
                <div class="col col-12 col-md-8 d-flex flex-column">
                    <az-input icon="fas fa-search fa-fw" v-model="search" />
                </div>
                <div class="col col-12 col-md-4 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-row mb-3">
                <div class="col col-12">
                    <az-input   
                        type="button-group"
                        :optionsList="[
                            { id: 'T', search: 'Todos' },
                            // { id: 'P', search: 'Por Período' },
                            { id: 'A', search: 'Ativos' },
                            { id: 'V', search: 'Vencendo' },
                            { id: 'C', search: 'Vencidos' },
                            { id: 'X', search: 'Sem Validade' },
                        ]"
                        optionsData="id"
                        v-model="filtro.validade" />
                </div>
                <div class="col col-12 col-md-6" v-if="false && filtro.validade == 'P'">
                    <az-periodo 
                        v-model="filtro" />
                </div>
            </div>

        </div>

        

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum contrato identificado.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="alert alert-warning" v-if="anexos_vencidos && anexos_vencidos.length">
                <a href="#" @click.prevent="ver_vencidos = !ver_vencidos" class="alert-link">
                    {{ anexos_vencidos.length }} arquivo(s) vencido(s)
                </a>
            </div>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <span v-if="dado && dado.operadora">
                            {{ dado.operadora.st_operadora }}
                        </span>
                        <i class="fas fa-caret-right mx-2"></i>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span v-if="dado.fl_recorrente" class="text-muted"
                            data-toggle="tooltip" data-placement="top" title="Recorrente"> 
                            <i class="fas fa-sync"></i>
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            <small class="text-muted mr-3" v-if="dado.dt_validade">
                                {{ getHumanDuration(dado.dt_validade) }}
                            </small>
                            <h5 class="mb-0 ml-1">
                                <span class="badge" :class="'badge-' + dado.situacao_cor" v-if="dado.dt_validade">
                                    {{ $util.getFormatDate(dado.dt_validade) }}
                                </span>
                            </h5>

                            <button type="button" class="btn btn-outline-primary btn-sm ml-3" @click="abrir_anexar_arquivo(dado)" v-if="!setup">
                                <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                {{ dado.arquivos.length }}
                            </button>

                            <a :href="dado.link_elo" target="_blank" type="button" class="btn btn-outline-primary btn-sm ml-1" v-if="!setup && dado && dado.link_elo">
                                Elo
                            </a>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <contrato-operadora ref="contrato" :geral="true" :setup="true" @refresh="load()" />

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
                :tem_validade="true"
                ref="upload"
                @refresh="load()"
                :multiple="true"
                :arquivos="item.arquivos"
                :parms="{ model_type: 'contratoOperadora', model_id: item.id_contrato_operadora }" />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import ContratoOperadora from './Operadora/ContratoOperadora.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            acao_anexar: false, 
            filtro: { 
                validade: "T",
                inicio: null,
                fim: null, 
                periodo: "a",
                mes: "", 
            },
            ver_vencidos: false, 
        }
    },

    props: ['cadastro', 'setup'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzFileUpload,
        ContratoOperadora,
        AzPeriodo, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');
            let hoje = this.$util.hoje();

            let lista = this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : [];

            lista = lista.filter(item => { 
                switch (this.filtro.validade) {
                    case 'C':
                        return item.situacao_cor == 'danger';

                    case 'V':
                        return item.situacao_cor == 'warning';

                    case 'A':
                        return item.situacao_cor == 'success' || item.situacao_cor == 'warning' || item.situacao_cor == 'secondary';

                    case 'X':
                        return item.situacao_cor == 'secondary';
                        
                    default:
                        return true;
                }
            })
            .filter(item => !this.ver_vencidos || item.arquivos.find(arq => arq.dt_validade && arq.dt_validade < hoje && !arq.fl_revogado));

            return _.orderBy(lista, item => _.get(item, 'operadora.st_operadora') + ' - ' + item.search);
        },

        anexos_vencidos: function () { 
            let hoje = this.$util.hoje();

            return this.lista.flatMap(item => item.arquivos ? item.arquivos.filter(item => item.dt_validade && item.dt_validade < hoje && !item.fl_revogado) : []);
        }

},

    methods: { 
        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) { 
                return "hoje";
            } else { 
                return moment
                    .duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje()))
                    .humanize(true);
            }
        },

        abrir_anexar_arquivo(item) { 
            this.item = item;
            this.acao_anexar = true;

            this.$nextTick(() => { 
                this.$refs.upload.abrir();
            });
        },

        load () { 
            this.$util.load(this, { 
                service:'contrato_operadoras',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },

        editar (item) { 
            if ( this.setup ) { 
                this.$refs.contrato.editar(item);
                return;
            }

            this.$util.abrirOperadora(item.operadora, "Contrato");
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'contrato_operadoras',
                dados: item,
            });

        },

    },

    created() { 
        this.search = this.$route.params.search ? this.$route.params.search : "";
    },

    mounted () { 
        this.load ();

        if ( !this.setup ) { 

            this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Contratos de Operadoras", method: this.fechar },
            ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>